<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="360px">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Send Message</span>
        </div>
        <div class="dialog-body">
          <el-form
            ref="send-form"
            :rules="rules"
            :model="sendFormData">
            <div
              v-if="isRenew"
              class="flex flex-align-center color-dark fs-14 mg-b-16">
              <span class="fw-600">Auto renew : {{autoRenew?'ON':'OFF'}}</span> <span
                v-if="autoRenew&&autoPayAt"
                class="color-dark fs-14 mg-l-5">(Debit Date {{autoPayAt}})</span>
            </div>
            <template v-if="(type==1||type==2&&hasSendEmail)&&isFina||type!=2&&isFina||isOnlyReferrer">
              <div class="form-item">
                <span class="mg-l-28">Referrer</span>
                <el-form-item >
                  <div class="flex-align-center">
                    <v-checkbox
                      v-if="!isOnlyReferrer"
                      v-model="sendFormData.referrer_send"
                      :is-boolean="false"
                      :disabled="!hasReferrerContactData"
                      class="mg-r-15"></v-checkbox>
                    <v-input
                      :value="referSendValue"
                      disabled
                    />
                  </div>
                </el-form-item>

              </div>
              <div class="form-item">
                <el-form-item
                  prop="referrer_content"
                  :rules="rules.input">
                  <v-input
                    v-model="sendFormData.referrer_content"
                    :disabled="sendFormData.referrer_send==0&&!isOnlyReferrer"
                    type="textarea"
                    :rows="4" />
                </el-form-item>
              </div>
            </template>
            <template v-if="!isOnlyReferrer">
              <div>
                <div class="form-item">
                  <span>Policyholder (SMS)</span>
                  <el-form-item >
                    <div class="flex-align-center">
                      <v-checkbox
                        v-model="sendFormData.is_sms_send"
                        :is-boolean="false"
                        :disabled="!sendHolderPhone"
                        class="mg-r-15"></v-checkbox>
                      <v-input
                        :value="policyholderSMS"
                        disabled
                      />
                    </div>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <el-form-item prop="content">
                    <v-input
                      v-model="sendFormData.content"
                      type="textarea"
                      :rows="4" />
                  </el-form-item>
                </div>
              </div>
              <div>
                <div class="form-item">
                  <span>Policyholder (Email)</span>
                  <el-form-item >
                    <div class="flex-align-center">
                      <v-checkbox
                        v-model="sendFormData.is_email_send"
                        :is-boolean="false"
                        :disabled="!sendHolderEmail"
                        class="mg-r-15"></v-checkbox>
                      <v-input
                        :value="policyholderEmail"
                        disabled
                      />
                    </div>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <el-form-item prop="content">
                    <v-input
                      v-model="sendFormData.email_content"
                      type="textarea"
                      :rows="4" />
                  </el-form-item>
                </div>
              </div>
              <div v-if="has_referrer&&!isCloseShare&&!isFina">
                <div class="form-item">
                  <span>Referrer (SMS)</span>
                  <el-form-item >
                    <div class="flex-align-center">
                      <v-checkbox
                        v-model="sendFormData.is_referrer_send"
                        :is-boolean="false"
                        :disabled="!hasReferrerContactData"
                        class="mg-r-15"></v-checkbox>
                      <v-input
                        :value="referSendValue"
                        disabled
                      />
                    </div>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <el-form-item prop="content">
                    <v-input
                      v-model="sendFormData.referrer_content"
                      type="textarea"
                      :rows="4" />
                  </el-form-item>
                </div>
              </div>
              <div v-if="has_share&&!isCloseShare&&!is_same_account">
                <div class="form-item">
                  <span>Authorized (SMS)</span>
                  <el-form-item >
                    <div class="flex-align-center">
                      <v-checkbox
                        v-model="sendFormData.is_share_send"
                        :is-boolean="false"
                        :disabled="!hasShareContactData"
                        class="mg-r-15"></v-checkbox>
                      <v-input
                        :value="shareSendValue"
                        disabled
                      />
                    </div>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <el-form-item prop="content">
                    <v-input
                      v-model="sendFormData.share_content"
                      type="textarea"
                      :rows="4" />
                  </el-form-item>
                </div>
              </div>
            </template>
          </el-form>
          <div class="flex-sb-center">
            <div>
              <v-button
                gray
                @click="onCancel">Cancel</v-button>
            </div>
            <div>
              <v-button
                v-if="skip"
                gray
                @click="onSkip">Skip</v-button>
              <v-button
                green
                :disabled="!can_send"
                @click="onSend">Send</v-button>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'

export default {
  name: 'select-send-message',
  mixins: [MixinRules,MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    initSmsContent: {
      type: String,
      default: ''
    },
    initEmailContent: {
      type: String,
      default: ''
    },
    initShareContent: {
      type: String,
      default: ''
    },
    initReferContent: {
      type: String,
      default: ''
    },
    lastContent: {
      type: String,
      default: ''
    },
    skip: {
      type: Boolean,
      default: true
    },
    showUsername:{
      type: Boolean,
      default: false
    },
    value:{
      type: Boolean,
      default: false
    },
    isEdit:{
      type: Boolean,
      default: false
    },
    isFina:{
      type: Boolean,
      default: false
    },
    isRenew:{
      type: Boolean,
      default: false
    },
    autoRenew:{
      type: Boolean,
      default: false
    },
    autoPayAt:{
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 0
    },
    updateContent: {
      type: Boolean,
      default: false
    },
    isOnlyReferrer:{
      type: Boolean,
      default: false
    },
    isAccountReferrer:{
      type: Boolean,
      default: false
    },
    isCloseShare:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      sendFormData: {
        content: '',
        email_content: '',
        share_content: '',
        referrer_content: '',
        send_type:'',
        customer_send:0,
        is_share_send:1,
        is_sms_send:1,
        is_email_send:1,
        is_referrer_send:1,
        referrer_send:0,
      }
    }
  },
  computed: {
    can_send(){
      let {is_share_send,is_sms_send,is_email_send,referrer_send} = this.sendFormData||{}
      return is_share_send==1||is_sms_send==1||is_email_send==1||this.isOnlyReferrer||!this.isOnlyReferrer&&referrer_send==1
    },
    referrer(){
      let {referrer={}} = this.form||{}
      let data = {}
      if(JSON.stringify(referrer) != '[]')
      {
        data =  referrer
      }
      return data||{}
    },
    share_user_infos(){
      let {referrer={},share_user_infos={}} = this.form||{}
      let data = {}
      if(JSON.stringify(share_user_infos) != '{}')
        data = share_user_infos
      return data||{}
    },
    is_same_account(){
      let {send_mobile} = this.referrer||{}
      if(this.has_referrer&&this.has_share)
        return send_mobile==this.share_user_infos.send_mobile
      return false
    },
    has_referrer(){
      return JSON.stringify(this.referrer) != '{}'
    },
    has_share(){
      return JSON.stringify(this.share_user_infos) != '{}'
    },
    referSendValue(){
      let {isrd_nm,send_mobile,send_email,identity,phone} = this.referrer||{}
      return `${isrd_nm} - ${send_mobile}`
    },
    hasReferrerContactData(){
      let {send_mobile=''} = this.referrer||{}
      return !!send_mobile
    },
    hasShareContactData(){
      let {send_mobile=''} = this.share_user_infos||{}
      return !!send_mobile
    },
    shareSendValue(){
      let {isrd_nm,send_mobile,send_email,identity,phone} = this.share_user_infos||{}
      return `${isrd_nm} - ${send_mobile}`
    },
    hasSendEmail(){
      let {send_email} = this.referrer||{}
      return !!send_email
    },
    isEmail() {
      if(this.type == 0) {
        return !this.isPersonal
      }
      if(this.type == 2) {
        return true
      }
      return false
    },
    isPersonal() {
      const { identity, cust_typ } = this.form||{}
      if(identity && identity == 1) {
        return true
      }
      if(cust_typ && cust_typ == 1) {
        return true
      }
      return false
    },
    currentName() {
      const { isrd_lst_nm, isrd_fst_nm, contact_nm, isrd_nm } = this.form||{}
      let name = ''
      if(isrd_nm){
        name = isrd_nm
      }else{
        name =  `${isrd_lst_nm} ${isrd_fst_nm}`
      }
      return this.isPersonal?name:contact_nm
    },
    sendContact(){
      let {send_type} = this.sendFormData||{}
      let send_phone = this.sendHolderPhone
      let email = this.sendHolderEmail
      if(send_type==3) {
        return this.currentName?`${this.currentName} - ${send_phone},${email}`:`${send_phone},${email}`
      }
      if(send_type==2)
        return  this.currentName?`${this.currentName} - ${email}`:email
      return  this.currentName?`${this.currentName} - ${send_phone}`:send_phone
    },
    sendHolderPhone(){
      const {
        mobile_no,
        phone,
        contact_phone,
        phone_no } = this.form||{}
      let send_phone = contact_phone||mobile_no || phone || phone_no
      return send_phone
    },
    sendHolderEmail(){
      const {
        email,
        contact_phone,
        draft_email,
      } = this.form||{}
      return email
    },
    policyholderSMS(){
      return  this.currentName?`${this.currentName} - ${this.sendHolderPhone}`:this.sendHolderPhone
    },
    policyholderEmail(){
      return  this.currentName?`${this.currentName} - ${this.sendHolderEmail}`:this.sendHolderEmail
    },
  },
  watch: {
    initReferContent: {
      immediate: true,
      handler(val, old) {
        this.sendFormData.referrer_content = val
      }
    },
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val
        if(val){
          this.sendFormData.content = this.initSmsContent
          this.sendFormData.email_content = this.initEmailContent
          this.sendFormData.share_content = this.initShareContent
          this.sendFormData.referrer_content =  this.initReferContent
          this.sendFormData.is_sms_send = this.sendHolderPhone?1:0
          this.sendFormData.is_email_send = this.sendHolderEmail?1:0
          this.sendFormData.is_share_send = this.has_share&&!this.is_same_account&&this.hasShareContactData?1:0
          this.sendFormData.is_referrer_send = this.has_referrer&&this.hasReferrerContactData?1:0
          if(!this.hasReferrerContactData) this.sendFormData.referrer_send = 0
        }
      }
    }
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
      this.dialog = false
      this.$emit('input',false)
    },
    onSend() {
      this.$refs['send-form'].validate((valid, rules) => {
        if(valid) {
          this.dialog = false
          this.$emit('send',this.sendFormData)
          this.$emit('input',false)
        }
        else {
          console.log(rules)
        }
      })
    },
    onSkip() {
      this.dialog = false
      this.$emit('skip')
      this.$emit('input',false)
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}
.dialog-container {

  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #1B1F23;
    }
  }
  .dialog-body{
    padding: 20px 15px;
  }
  h3 {
    padding-bottom: 10px;
  }
  p {
    padding-bottom: 10px;
  }
  .dialog-footer {
    margin: 15px -15px -15px;
    padding: 15px;
    text-align: right;
    background: #F9FAFB;
  }
  .form-item {
    & > span {
      font-weight: 600;
      font-size: 14px;
    }
  }
}
</style>
